import { Typography } from '@mui/material';
import { AuthScreenLayout, TextButton, TypographySubtitle, TypographyTitle } from 'components';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ROUTES from 'Routes/routes';
import { LocationState } from 'utils';
import TulLogo from '../../../src/images/1Tul-logo.png';
import LoginFormContainer from '../../components/Forms/LoginFormContainer';

type LoginMethod = 'username' | 'phone';

interface LoginLocationState extends LocationState {
    prefillPhone?: string;
    preferPhoneLogin?: boolean;
}

const Login = () => {
    const { push } = useHistory();
    const location = useLocation<LoginLocationState>();
    const [currentLoginMethod, setCurrentLoginMethod] = useState<LoginMethod>('username');

    const prefillPhone = location.state?.prefillPhone;
    const preferPhoneLogin = location.state?.preferPhoneLogin;

    const handleLoginMethodChange = (method: LoginMethod) => {
        setCurrentLoginMethod(method);
    };

    return (
        <AuthScreenLayout>
            <Typography
                sx={{ mt: 4, mb: 2, display: 'flex', alignItems: 'center' }}
                variant="subtitle1"
                component="div"
            >
                <img src={TulLogo} alt="1TUL Logo" width={60} />
            </Typography>

            <TypographyTitle
                align="center"
                sx={{
                    marginY: 5,
                    marginX: 0,
                }}
            >
                Welcome back
            </TypographyTitle>
            <TypographySubtitle align="center" sx={{ marginBottom: 8 }}>
                Login to manage your account
            </TypographySubtitle>

            {!isEmpty(location.state?.referrer_message) && (
                <TypographySubtitle
                    align="center"
                    sx={{
                        margin: 0,
                    }}
                >
                    {location.state?.referrer_message || ''}
                </TypographySubtitle>
            )}

            <LoginFormContainer
                onLoginMethodChange={handleLoginMethodChange}
                initialPhone={prefillPhone}
                preferPhoneLogin={preferPhoneLogin}
            />

            <TypographyTitle
                style={{ marginTop: '16px' }}
            >{`Don't have an account? `}</TypographyTitle>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <TextButton
                    align="center"
                    onClick={() => push(ROUTES.Register.path, location.state)}
                >
                    <Typography align="center">Sign Up</Typography>
                </TextButton>
            </div>

            {/* Only show the bottom section for username login */}
            {currentLoginMethod === 'username' && (
                <>
                    <TypographyTitle
                        align="center"
                        sx={{
                            marginTop: 5,
                            marginX: 0,
                        }}
                    >
                        Forget something?
                    </TypographyTitle>
                    <TextButton align="center" onClick={() => push(ROUTES.ForgotPassword.path)}>
                        <Typography align="center">Forgot your email or password?</Typography>
                    </TextButton>
                    <TextButton align="center" onClick={() => push(ROUTES.ForgotUsername.path)}>
                        <Typography align="center">Forgot your username?</Typography>
                    </TextButton>
                    <TypographyTitle sx={{ mt: 4 }} align="center">
                        Want more information?
                    </TypographyTitle>
                    <TextButton
                        align="center"
                        onClick={() => {
                            push('/');
                        }}
                    >
                        <Typography align="center">Visit our information page</Typography>
                    </TextButton>
                </>
            )}
        </AuthScreenLayout>
    );
};

export default Login;
